import React from "react";
import {Swiper} from "swiper/react";

export const CustomSlider = ({children, ...props}) => (
    <div className="custom-slide">
        <Swiper
            className="movieShowcase__container col-12"
            navigation={true}
            grabCursor={false}
            draggable={false}
            loop={false}
            spaceBetween={12}
            slidesPerView="auto"
            watchOverflow={true}
            centeredSlides={false}
            preventClicksPropagation={true}
            preventClicks={true}
            scrollbar={false}
            slideToClickedSlide={true}
            loopFillGroupWithBlank={false}
            breakpoints={{
                1850: {
                    slidesPerView: 7,
                    slidesPerGroup: 1,
                },
                1650: {
                    slidesPerView: 6,
                    slidesPerGroup: 1,
                },
                970: {
                    slidesPerView: 5,
                    slidesPerGroup: 1,
                },
                600: {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                },
                450: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                },
                0: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                },
            }}
            {...props}
        >
            {children}
        </Swiper>
    </div>
);

export default CustomSlider;
